export default "__VITE_ASSET__b2560c0b__"